export default "__VITE_ASSET__DszlQZzm__"